const newsItems = [
  {
    id: 1,
    title: 'Nuevo Álbum de Artista Internacional',
    date: '15 de Marzo, 2024',
    category: 'Lanzamientos',
    excerpt: 'El esperado álbum que promete revolucionar la escena musical internacional ya está disponible en todas las plataformas.',
    image: 'https://public.readdy.ai/ai/img_res/c1a15af6743ab0e57d2815a89dbef5a7.jpg'
  },
  {
    id: 2,
    title: 'Festival de Música en Cúcuta',
    date: '10 de Marzo, 2024',
    category: 'Eventos',
    excerpt: 'Se anuncia el festival más grande del año con artistas nacionales e internacionales. No te lo puedes perder.',
    image: 'https://readdy.ai/api/search-image?query=Large%20outdoor%20music%20festival%20stage%20at%20sunset%20with%20massive%20crowd%2C%20colorful%20stage%20lights%20and%20LED%20screens%2C%20energetic%20concert%20atmosphere%2C%20professional%20event%20photography%2C%20vibrant%20festival%20setting%2C%20dynamic%20lighting%20effects%2C%20Colombian%20music%20festival&width=600&height=400&seq=news2&orientation=landscape'
  },
  {
    id: 3,
    title: 'Entrevista Exclusiva con DJ Famoso',
    date: '5 de Marzo, 2024',
    category: 'Entrevistas',
    excerpt: 'Conversamos con uno de los DJs más reconocidos sobre su carrera y próximos proyectos musicales.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20DJ%20being%20interviewed%20in%20modern%20radio%20studio%2C%20professional%20broadcasting%20equipment%2C%20warm%20studio%20lighting%2C%20intimate%20interview%20setting%2C%20contemporary%20radio%20station%20interior%2C%20professional%20media%20photography%2C%20engaging%20conversation%20atmosphere&width=600&height=400&seq=news3&orientation=landscape'
  }
];

export default function News() {
  return (
    <section id="news" className="py-16 sm:py-24 lg:py-32 bg-[#1a1a1a]">
      <div className="px-4 sm:px-8 lg:px-20">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#d4af37] mb-3 sm:mb-4 lg:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            NOTICIAS
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto px-4">
            Mantente al día con las últimas novedades del mundo musical
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {newsItems.map((news) => (
            <article
              key={news.id}
              className="bg-[#0a0a0a] rounded-xl overflow-hidden border border-[#d4af37]/20 hover:border-[#d4af37] transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-48 sm:h-56 overflow-hidden">
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#d4af37] text-black px-3 py-1 rounded-full text-xs font-semibold uppercase">
                    {news.category}
                  </span>
                </div>
              </div>

              <div className="p-4 sm:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-calendar-line text-[#d4af37] text-sm sm:text-base"></i>
                  </div>
                  <span className="text-white/60 text-xs sm:text-sm">{news.date}</span>
                </div>

                <h3 className="text-white text-lg sm:text-xl font-bold mb-3 group-hover:text-[#d4af37] transition-colors duration-300" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {news.title}
                </h3>

                <p className="text-white/70 text-xs sm:text-sm mb-4 leading-relaxed">
                  {news.excerpt}
                </p>

                <button className="flex items-center gap-2 text-[#d4af37] font-semibold text-xs sm:text-sm hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  Leer más
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
